// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"e953f768","391":"30054c42","874":"70231bbb"}[chunkId] + ".chunk.css";
};